import React, { Component } from "react";
import { Card, CardBody, Col, Collapse, Row } from "reactstrap";

import {
  updateSessionOutOfGymStatus,
  SESSION_TYPES,
} from "../../../modules/game_session";

import Hr from "../../components/hr/hr";
import Button from "../button/button";
import { NavLink } from "react-router-dom";
import { withWhiteLabelContext } from "react-whitelabel";

import "react-tippy/dist/tippy.css";
import { Tooltip } from "react-tippy";

import "./game-session-card.css";

class GameSessionCard extends Component {
  constructor(props) {
    super(props);

    let isAssignedForOOG = this.props.gameSession.assigned_for_out_of_gym;
    let isAssignedForHomePlay = this.props.gameSession.assigned_for_home_play;

    this.OWNED_SESSION_TYPE = 1;
    this.READY_MADE_SESSION_TYPE = 2;
    this.state = {
      isOpenActivities: false,
      isUpdatingOutOfGymStatus: false,
      isAssignedForOOG: isAssignedForOOG,
      isAssignedForHomePlay: isAssignedForHomePlay,
    };
  }

  async updateHomePlayStatus() {
    const { gameSession, player } = this.props;

    const { isUpdatingOutOfGymStatus } = this.state;

    if (isUpdatingOutOfGymStatus) {
      return;
    }

    this.setState({
      isUpdatingOutOfGymStatus: true,
    });

    let response = await updateSessionOutOfGymStatus(
      player.id,
      gameSession.id,
      SESSION_TYPES.HOME_PLAY
    );

    let isAssignedForHomePlay = this.state.isAssignedForHomePlay;
    if (response.data.success) {
      isAssignedForHomePlay = response.data.new_status;
    }

    this.setState({
      isUpdatingOutOfGymStatus: false,
      isAssignedForHomePlay: isAssignedForHomePlay,
    });
  }

  async updateOutOfGymStatus() {
    const { gameSession, player } = this.props;

    const { isUpdatingOutOfGymStatus } = this.state;

    if (isUpdatingOutOfGymStatus) {
      return;
    }

    this.setState({
      isUpdatingOutOfGymStatus: true,
    });

    let response = await updateSessionOutOfGymStatus(
      player.id,
      gameSession.id,
      SESSION_TYPES.OUT_OF_GYM
    );

    let isAssignedForOOG = this.state.isAssignedForOOG;
    if (response.data.success) {
      isAssignedForOOG = response.data.new_status;
    }

    this.setState({
      isUpdatingOutOfGymStatus: false,
      isAssignedForOOG: isAssignedForOOG,
    });
  }

  render() {
    const {
      activities,
      gameSession,
      player,
      isActive,
      onClickPlayActiveSession,
      onClickSetActive,
      user,
      label
    } = this.props;
    const {
      isOpenActivities,
      isAssignedForOOG,
      isAssignedForHomePlay,
    } = this.state;

    const { outOffGymToggleLabel } = label.gameSessionCard;

    const _activities = gameSession._activities;

    let allSkills = [];
    let allPositions = [];
    let durationSum = 0;
    for (let index in _activities) {
      let currentActivity = _activities[index];
      if (allSkills.indexOf(currentActivity.skill.name) === -1) {
        allSkills.push(currentActivity.skill.name);
      }

      if (allPositions.indexOf(currentActivity.position.name) === -1) {
        allPositions.push(currentActivity.position.name);
      }

      durationSum += currentActivity.game.duration;
    }

    let durationsInMinutes = (durationSum / 60).toFixed(1);

    const activitySkillsDisplay = allSkills && allSkills.join(", ");
    const activityPositionDisplay = allPositions && allPositions.join(", ");

    let currentUserId;
    if (user) {
      currentUserId = user.currentUserId;
    } else {
      currentUserId = -1;
    }

    let moreRestoreButtonContent = (
      <span>
        <Tooltip title="Allows Care Partners to access and play this session with the selected player">
          <span className="restore_tooltip">
            <i className="fa fa-info-circle"></i>
          </span>
        </Tooltip>{" "}
        {outOffGymToggleLabel}
      </span>
    );
    let homePlayButtonContent = (
      <span>
        <Tooltip title="Assign this session to the player's Home Play plan (requires Home Play activation)">
          <span className="restore_tooltip">
            <i className="fa fa-info-circle"></i>
          </span>
        </Tooltip>{" "}
        Home Play
      </span>
    );
    return (
      <Card
        className={`ml-1 mr-2 mt-1 px-0 border ${
          isActive ? "shadow-lg border-primary" : "shadow-sm"
        }`}
      >
        <CardBody className="m-0 px-0 py-2">
          <Col className="mx-0 px-2">
            <Row className="mx-0 mb-1 p-0">
              <Col md={6} className="mp-0">
                <Row className="mp-0">
                  <h5 className="mb-0 pb-0">
                    {gameSession.game_session_name ||
                      gameSession.name ||
                      "<No Active Session"}
                    <Hr />
                  </h5>
                  {gameSession.type === this.READY_MADE_SESSION_TYPE ? (
                    <span className="ready_made_session_sign">
                      {" "}
                      RESTORE Recommended
                    </span>
                  ) : (
                    ""
                  )}
                </Row>
                <div className="m-0 px-0 py-1 secondary-color small">
                  <Row className="mp-0">
                    <p className="mx-1 my-0 p-0">
                      <span className="pr-2 font-weight-bold">Skill(s):</span>
                      {activitySkillsDisplay}
                    </p>
                  </Row>
                  <Row className="mp-0">
                    <p className="mx-1 my-0 p-0">
                      <span className="pr-2 font-weight-bold">
                        Position(s):
                      </span>
                      {activityPositionDisplay}
                    </p>
                  </Row>
                  <Row className="mp-0">
                    <p className="mx-1 my-0 p-0">
                      <span className="pr-2 font-weight-bold">
                        Est Play Time:
                      </span>
                      {durationsInMinutes} min
                    </p>
                  </Row>
                </div>
              </Col>
              <Col className="ml-4 mr-1 my-0 pl-2 pr-1 py-0 border-left border-info notes_container">
                <Row className="mp-0">
                  <p className="mp-0 font-italic">Notes:</p>
                </Row>
                <Row className="mp-0 border-left background-light-grey-color">
                  <p className="m-0 pl-2 pr-0 py-0 small secondary-color">
                    {gameSession.notes}
                  </p>
                </Row>
              </Col>
            </Row>
            <Row className="mx-0 mb-1 p-0">
              <Col md={5} className="mp-0">
                <Row className="mx-0 my-2 p-0 game_session_card_button_container">
                  {!isActive && (
                    <Button
                      size="sm"
                      color="success"
                      outline
                      className="mr-1"
                      onClick={onClickSetActive}
                      text="Make Active"
                    />
                  )}
                  {onClickPlayActiveSession && (
                    <Button
                      size="sm"
                      color={`${isActive ? "primary" : "info"}`}
                      outline
                      className="mr-1"
                      onClick={onClickPlayActiveSession}
                      text="Play Session"
                    />
                  )}
                  {player && (
                    <NavLink
                      to={{
                        pathname: `/player/${player.id}/gameSession/${gameSession.id}`,
                        player: player,
                      }}
                    >
                      {currentUserId === gameSession.owner_id && (
                        <Button
                          size="sm"
                          outline
                          className="mr-1"
                          text="Edit"
                        />
                      )}
                    </NavLink>
                  )}
                  {player && !isAssignedForOOG && (
                    <Button
                      size="sm"
                      color="default"
                      outline
                      className="mr-1"
                      onClick={this.updateOutOfGymStatus.bind(this)}
                      iconClass="fa-toggle-on fa-flip-horizontal oog_toggle"
                      text={moreRestoreButtonContent}
                    />
                  )}
                  {player && isAssignedForOOG && (
                    <Button
                      size="sm"
                      color="danger"
                      outline
                      className="mr-1"
                      onClick={this.updateOutOfGymStatus.bind(this)}
                      iconClass="fa-toggle-on oog_toggle"
                      text={moreRestoreButtonContent}
                    />
                  )}

                  {player && !isAssignedForHomePlay && (
                    <Button
                      size="sm"
                      color="default"
                      outline
                      className="mr-1 home_play_button"
                      onClick={this.updateHomePlayStatus.bind(this)}
                      iconClass="fa-toggle-on fa-flip-horizontal home_play_toggle"
                      text={homePlayButtonContent}
                    />
                  )}
                  {player && isAssignedForHomePlay && (
                    <Button
                      size="sm"
                      color="danger"
                      outline
                      className="mr-1 home_play_button"
                      onClick={this.updateHomePlayStatus.bind(this)}
                      iconClass="fa-toggle-on home_play_toggle"
                      text={homePlayButtonContent}
                    />
                  )}
                </Row>
              </Col>
            </Row>

            {activities && (
              <Row className="mx-0 mb-1 p-0 small">
                <p className="mp-0 container-fluid">
                  <Hr />
                </p>
                <Row className="mp-0 container-fluid">
                  <p
                    className="mp-0 font-italic font-weight-bold secondary-color pointer"
                    onClick={() => {
                      this.setState({ isOpenActivities: !isOpenActivities });
                    }}
                  >
                    <i
                      className={`mx-2 fa ${
                        isOpenActivities ? "fa-caret-down" : "fa-caret-right"
                      }`}
                    />
                    Activities ({activities.length})
                  </p>
                </Row>
                <Collapse isOpen={isOpenActivities}>
                  <Row className="mp-0">
                    {activities.map((activity) => (
                      <div className="m-0 p-1" style={{ width: 200 }}>
                        {activity}
                      </div>
                    ))}
                  </Row>
                </Collapse>
              </Row>
            )}
          </Col>
        </CardBody>
      </Card>
    );
  }
}

export default withWhiteLabelContext(GameSessionCard);



// WEBPACK FOOTER //
// ./src/components/components/game-session-card/game-session-card.js